.inputGroup {
  border: 1px solid transparent;
  width: fit-content;
  display: flex;
  align-items: center;
  border-radius: $component-border-radius-md;

  &.delayed {
    border: 1px solid $ontime-delay-text;
  }

  input {
    max-width: fit-content;
    border-radius: $component-border-radius-md 0 0 $component-border-radius-md;
    border: none;
    padding-right: 0;
  }

  button {
    width: 1.5rem;
    height: 2rem;
    border-radius: 0 $component-border-radius-md $component-border-radius-md 0;
    border: none;
  }
}
